import { setLocale, useLocale } from '@/lib/locale'
import { useUi } from '@/lib/i18n/ui'

/**
 * English / Arabic switch for the bilingual face. A segmented pill rather
 * than a globe icon: the visible other-language label ("عربي" when English
 * is active) is what a bilingual customer scans for.
 */
export default function LanguageToggle({ onDark = false }: { onDark?: boolean }) {
  const locale = useLocale()
  const t = useUi()
  const base = 'cursor-pointer rounded-full px-3 py-1.5 text-sm font-semibold transition'
  const active = onDark ? 'bg-white text-[var(--qa-primary-deep)]' : 'bg-[var(--qa-primary)] text-white'
  const idle = onDark ? 'text-white/80 hover:text-white' : 'text-slate-600 hover:text-slate-900'
  return (
    <div
      role="group"
      aria-label={t.languageToggleAria}
      className={`inline-flex items-center rounded-full p-1 ${onDark ? 'bg-white/10' : 'bg-slate-100'}`}
    >
      <button
        type="button"
        lang="en"
        onClick={() => setLocale('en')}
        aria-pressed={locale === 'en'}
        className={`${base} ${locale === 'en' ? active : idle}`}
      >
        EN
      </button>
      <button
        type="button"
        lang="ar"
        onClick={() => setLocale('ar')}
        aria-pressed={locale === 'ar'}
        className={`${base} ${locale === 'ar' ? active : idle}`}
      >
        عربي
      </button>
    </div>
  )
}
